// extracted by mini-css-extract-plugin
export default {"message":"webpack-containers-Organizations-Insights-module__message","heading":"webpack-containers-Organizations-Insights-module__heading"};